module.exports = __webpack_public_path__ + "static/media/spos2.33f4201e.png";